import React, { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import { useApi } from '../hooks/useApi';
import logger from '../utils/logger';
import env from '../config/env';
import { useSettings } from '../context/SettingsContext';
import {
  BadgePercent,
  PackageOpen,
  CheckCircle2,
  XCircle,
  Ruler,
  PaintBucket,
  Box,
  Layers,
  Tag,
  Eye,
} from 'lucide-react';

const DetajeModal = ({ produktId, onClose }) => {
  const { getCurrencyCode } = useSettings();
  const currencyCode = getCurrencyCode();
  const [selectedImage, setSelectedImage] = useState('');

  const { data: produkt, loading } = useApi(
    () => apiService.get(`/produkte/${produktId}/detaje`),
    [produktId],
    { immediate: true, showNotifications: false }
  );

  useEffect(() => {
    if (produkt?.foto?.length > 0) {
      setSelectedImage(`${env.API_URL_Image}/storage/${produkt.foto[0].file_path}`);
    }
  }, [produkt]);

  if (!produkt) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 dark:bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
     <div className="card-premium w-full max-w-5xl max-h-[90vh] overflow-y-auto p-6 space-y-6 animate-fadeIn">

        
        {/* Header: Emri dhe Close */}
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200 dark:border-dark-700">
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 flex flex-col gap-1">
            <span className="flex items-center gap-2"><PackageOpen size={24} /> {produkt.emri}</span>
            {produkt.emri_mk && (
              <span className="text-base text-gray-500 dark:text-gray-400 pl-8 italic">({produkt.emri_mk})</span>
            )}
          </h2>
          <button onClick={onClose} className="text-gray-400 dark:text-gray-500 hover:text-red-600 dark:hover:text-red-400 transition-colors">
            <XCircle size={28} />
          </button>
        </div>

        {/* Përmbajtja */}
        <div className="flex flex-col md:flex-row">
          {/* Galeria */}
          <div className="w-full md:w-1/2 p-6">
            <div className="w-full h-96 border border-gray-200 dark:border-dark-700 rounded-xl overflow-hidden shadow-sm mb-4 bg-white dark:bg-dark-800 flex items-center justify-center">
             <img
  src={selectedImage || 'https://dummyimage.com/300x375/cccccc/000000&text=Pa+Foto'}
  alt="Foto Kryesore"
   className="max-h-full max-w-full object-contain"
  onError={(e) => {
    e.target.onerror = null;
    e.target.src = 'https://dummyimage.com/300x375/cccccc/000000&text=Pa+Foto';
  }}
/>

            </div>
            <div className="flex gap-2 overflow-x-auto">
              {produkt.foto?.map((f, i) => (
                <img
                  key={i}
                  src={`${env.API_URL_Image}/storage/${f.file_path}`}
                  alt=""
                  onClick={() => setSelectedImage(`${env.API_URL_Image}/storage/${f.file_path}`)}
                  className={`w-16 h-16 object-contain rounded-lg border-2 cursor-pointer transition hover:scale-105 ${selectedImage.includes(f.file_path) ? 'border-primary-500 dark:border-primary-400' : 'border-gray-300 dark:border-dark-600'}`}
                />
              ))}
            </div>
          </div>

          {/* Detajet */}
          <div className="w-full md:w-1/2 p-6 flex flex-col justify-between">
            <div className="space-y-4 text-sm text-gray-700 dark:text-gray-300">
              <div className="grid grid-cols-2 gap-y-2">
                <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400"><Tag size={16} /> Kodi:</div>
                <div className="font-medium">{produkt.kodi}</div>


                <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400"><Box size={16} /> Çmimi Blerjes:</div>
                <div>{produkt.cmimi_blerjes} {currencyCode}</div>

                <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400"><Box size={16} /> Çmimi Shitjes:</div>
                <div className="font-semibold text-primary-600 dark:text-primary-400">{produkt.cmimi_shitjes} {currencyCode}</div>

                {produkt.zbritje_perqindje > 0 && (
                  <>
                    <div className="flex items-center gap-2 text-orange-600 dark:text-orange-400"><BadgePercent size={16} /> Zbritje:</div>
                    <div className="text-orange-600 dark:text-orange-400 font-semibold">{produkt.zbritje_perqindje}%</div>
                  </>
                )}

                <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400"><Eye size={16} /> Statusi:</div>
                <div>
                 <span className={`badge-premium inline-flex items-center gap-1 ${
  parseInt(produkt.eshte_aktiv) === 1
    ? 'badge-success'
    : 'badge-danger'
}`}>
  {parseInt(produkt.eshte_aktiv) === 1 ? (
    <>
      <CheckCircle2 size={14} /> Aktiv
    </>
  ) : (
    <>
      <XCircle size={14} /> Joaktiv
    </>
  )}
</span>

                </div>

                <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400"><Layers size={16} /> Kategoria:</div>
                <div>
                  <span className="badge-secondary text-xs font-medium px-2 py-1 rounded-full">
                    {produkt.kategoria?.emri || `#${produkt.kategoria_id}`}
                  </span>
                </div>

                <div className="flex items-center gap-2 text-gray-600 dark:text-gray-400"><Layers size={16} /> Furnizuesi:</div>
                <div>
                  <span className="badge-primary text-xs font-medium px-2 py-1 rounded-full">
                    {produkt.furnizues?.emri || (produkt.furnizues_id ? `#${produkt.furnizues_id}` : "-")}
                  </span>
                </div>
              </div>

                  {/* Përshkrimet në dy gjuhë */}
<div className="pt-6 space-y-3 text-sm">
  {produkt.pershkrimi && (
    <div>
      <h4 className="font-semibold text-gray-800 dark:text-gray-200">Përshkrimi (shqip)</h4>
      <p className="text-gray-700 dark:text-gray-300">{produkt.pershkrimi}</p>
    </div>
  )}

  {produkt.pershkrimi_mk && (
    <div>
      <h4 className="font-semibold text-gray-800 dark:text-gray-200">Përshkrimi (maqedonisht)</h4>
      <p className="text-gray-700 dark:text-gray-300">{produkt.pershkrimi_mk}</p>
    </div>
  )}
</div>

              {/* Variacionet */}
              {produkt.variacione?.length > 0 && (
                <div className="pt-4">
                  <h3 className="text-base font-semibold mb-2 flex items-center gap-2 text-gray-800 dark:text-gray-200"><Ruler size={18} /> Madhësitë & Ngjyrat</h3>
                  <div className="card-premium overflow-hidden p-0">
                    <table className="table-premium">
                      <thead>
                        <tr>
                          <th>Ngjyra</th>
                          <th>Madhësia</th>
                          <th>Sasia</th>
                        </tr>
                      </thead>
                      <tbody>
                        {produkt.variacione.map((v, i) => (
                          <tr key={i} className="text-center">
                            <td>{v.ngjyra}</td>
                            <td>{v.madhesia}</td>
                            <td className="font-semibold">{v.sasia}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetajeModal;
